module.exports = require('./_global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/._core-js@2.4.1@core-js/library/modules/_html.js
 ** module id = 389
 ** module chunks = 0 1
 **/